module.exports = __webpack_public_path__ + "media/images/weather/211_day-823b3ffc62acda7e64733f9c787aa6b2.png";